import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

export function useRouteModal(id: string) {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const isRouteOpen = useMemo(() => {
    const routeState = location.state?.useRouteModalValue;

    if (!Array.isArray(routeState)) {
      return false;
    }

    return routeState.includes(id);
  }, [location.state?.useRouteModalValue, id]);

  const addToRoute = useCallback(() => {
    const routeState = location.state?.useRouteModalValue || [];

    if (routeState.includes(id)) {
      return;
    }

    navigate(`?${searchParams.toString()}`, {
      state: { useRouteModalValue: [...routeState, id] },
    });
  }, [location.state?.useRouteModalValue, id, navigate, searchParams]);

  const [isOpen, setIsOpen] = useState(isRouteOpen);

  useEffect(() => {
    setIsOpen(isRouteOpen);
  }, [isRouteOpen]);

  const onChange = useCallback(
    (newValue: boolean) => {
      if (newValue) {
        if (!isRouteOpen) {
          addToRoute();
        }
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    },
    [isRouteOpen, addToRoute],
  );

  return [isOpen, onChange] as const;
}
